<template>
  <div class="up-file">
    <div class="work-info">
      <div>作品url:{{urlStr}}</div>
      <div>作品id:{{id}}</div>
    </div>
    <div class="work-btn" @click="save">转换</div>
    <div class="info-tips">{{tips}}</div>
    <div v-if="number">进度：{{newNumber}} / {{number}}</div>
    <div class="info-list">
      <div v-for="(item,index) in tipsInfoSuccess">
        <div class="success-tips">{{item.str}}</div>
      </div>
      <div v-for="(item,index) in tipsInfoFail" :key="index">
        <div class="success-fail">
          {{item.str}}
          <img :src="item.imgSrc" alt />
          <span @click="nextUp(item,index)" v-if="over">重新上传</span>
        </div>
      </div>
    </div>
    <div v-if="over">已完成上传，上传失败的请尝试点击错误信息后重新上传按钮。或联系管理员。</div>
    <div @click="upFileAll(0)" class="work-btn" v-if="tipsInfoFail.length">错误图片全部重新上传</div>
    <div class="loading" v-show="showLoading">
      <van-loading size="24px">上传中，请勿关闭浏览器...</van-loading>
    </div>

    <div class="loading" v-if="isPlay && !over">
      <van-loading size="24px">上传中，请勿关闭浏览器...</van-loading>
    </div>
    <!-- <img src="base" alt=""> -->
  </div>
</template>

<script>
import PDFJS from "pdfjs-dist";
import { TextLayerBuilder } from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";
export default {
  name: "upFile",
  data() {
    return {
      showLoading: false,
      urlStr: this.getQueryString("url"),
      id: this.getQueryString("id"),
      isPlay: false,
      over: false,
      tips: "",
      newImgBase: "",
      newNumber: 1,
      number: 0, //总页数
      name: "测试",
      tipsInfoSuccess: [],
      tipsInfoFail: [],
      base: "",
      linshi:[],
    };
  },
  methods: {
    upFileAll(index) {
      if (+index < this.tipsInfoFail.length) {
        this.showLoading = true;
        let formdata = new FormData();
        formdata.append("image", this.tipsInfoFail[+index].img);
        this.$http.post("imgupload", formdata).then(
          res => {
            if (res.data.code == 200) {
              this.tipsInfoFail[+index].str = this.tipsInfoFail[+index].str.split("失败")[0] + `成功 图片地址： ${res.data.data}`;
              this.linshi.push(+index);
              // this.tipsInfoSuccess.push(this.tipsInfoFail[_index]);
              // this.tipsInfoFail.splice(_index, 1);
            }
            this.upFileAll(index+1)
          },
          e => {
           this.upFileAll(index+1)
          }
        );
      }else {
        if (this.linshi.length) {
          for (let j = 0; j < this.linshi.length;j++) {
            this.tipsInfoSuccess.push(this.tipsInfoFail[this.linshi[j] - j]);
            this.tipsInfoFail.splice(this.tipsInfoFail[this.linshi[j] - j], 1);
          }
          this.showLoading = false;
        }
      }
    },
    nextUp(item, _index) {
      if (this.showLoading) return;
      this.showLoading = true;
      let index = item.index;
      this.renderView(+index, "one", _index);
    },
    bindWork() {
      this.$http
        .post("workcheck", {
          bid: this.id,
          last: this.number
        })
        .then(
          res => {
            this.$toast(res.data.msg);
            if (res.data.code == 200) {
              this.tips = "图书状态已变为以改变";
            }
          },
          e => {
            this.$toast(res.data.msg || "系统错误");
          }
        );
    },
    createCanvas() {
      if (this.newNumber > this.number) {
        this.newNumber--;
        this.tips = `全部图片已上传完成，正在进行图书状态修改`;
        this.over = true;
        this.bindWork();
      } else {
        this.tips = `正在上传第${this.newNumber}页图片...`;
        this.renderView(this.newNumber);
      }
    },
    save() {
      if (this.isPlay) return;
      if (!this.urlStr) {
        alert("未识别作品地址");
        return;
      }
      if (!this.id) {
        alert("未识别作品id");
        return;
      }
      let that = this;
      let pdfPath = this.urlStr.trim();
      this.isPlay = true;
      this.tips = "正在加载文件中,请稍等...";
      var loadingTask = PDFJS.getDocument(pdfPath);
      PDFJS.GlobalWorkerOptions.workerSrc = "pdfjs-dist/build/pdf.worker.js";
      loadingTask.promise
        .then(doc => {
          this.tips = "文件加载完成，解析文件准备上传...";
          this.doc = doc;
          this.number = doc.numPages;
          this.createCanvas();
        })
        .then(
          res => {
            console.log(res);
          },
          err => {
            that.tips = "文件解析错误，请确认文件路径正确";
            console.log(err);
          }
        );
    },
    renderView(pageNum, type, _index) {
      this.doc.getPage(+pageNum).then(page => {
        let viewport = page.getViewport(3);
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let proportion = viewport.height / viewport.width;
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        let renderContext = {
          canvasContext: context,
          viewport
        };
        let renderTask = page.render(renderContext);
        renderTask.promise.then(() => {
          var image = new Image();
          image.src = canvas.toDataURL("image/png"); //canvas转化为img
          this.newImgBase = this.dataURLtoFile(
            image.src,
            `${this.id}_${this.newNumber}`
          );
          if (type === "one") {
            this.oneUpImg(_index);
          } else {
            this.upImg(image.src);
          }
        });
      });
    },
    oneUpImg(_index) {
      var formdata = new FormData();
      formdata.append("image", this.newImgBase);
      this.$http.post("imgupload", formdata).then(
        res => {
          this.showLoading = false;
          this.$toast(res.data.msg);
          if (res.data.code == 200) {
            this.tipsInfoFail[_index].str = `第${this.newNumber}上传成功 图片地址： ${res.data.data}`;
            this.tipsInfoSuccess.push(this.tipsInfoFail[_index]);
            this.tipsInfoFail.splice(_index, 1);
          }
        },
        e => {
          this.showLoading = false;
          this.$toast(res.data.msg || "网络错误");
        }
      );
    },
    upImg(imgSrc) {
      var formdata = new FormData();
      formdata.append("image", this.newImgBase);
      this.$http.post("imgupload", formdata).then(
        res => {
          try {
            if (res && res.data && res.data.code == 200) {
              this.tipsInfoSuccess.push({
                str: `第${this.newNumber}上传成功 图片地址： ${res.data.data}`,
                index: this.newNumber
              });
            } else {
              this.tipsInfoFail.push({
                str: `第${this.newNumber}上传失败`,
                index: this.newNumber,
                img: this.newImgBase,
                imgSrc: imgSrc
              });
            }
            this.newNumber++;
            this.createCanvas();
          } catch (e) {
            this.tipsInfoFail.push({
              str: `第${this.newNumber}上传失败`,
              index: this.newNumber,
              img: this.newImgBase,
              imgSrc: imgSrc
            });
            this.newNumber++;
            this.createCanvas();
          }
        },
        e => {
          this.tipsInfoFail.push({
            str: `第${this.newNumber}上传失败`,
            index: this.newNumber,
            img: this.newImgBase,
            imgSrc: imgSrc
          });
          this.newNumber++;
          this.createCanvas();
        }
      );
    },
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    }
  }
};
</script>

<style lang="scss">
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}
.success-tips {
  color: #28a745;
  margin: 20px 0;
}
.success-fail {
  display: flex;
  align-items: center;
  color: red;
  margin: 20px 0;
  img {
    margin-left: 10px;
    width: 250px;
    height: auto;
    border: 1px solid #eeeeee;
  }
}

.up-file {
  width: 750px;
  margin: 0 auto;
  padding: 20px;
  .work-btn {
    width: 180px;
    height: 40px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background: #28a745;
    font-size: 16px;
    cursor: pointer;
    margin: 60px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upFile.vue